<template>
    <div class="w3-display-container" style="height: 100vh">
        <div class="w3-display-middle w3-center">
            <h2 class="w3-text-dark-gray">
                <b>Pega no meu SAC!</b> <br><br>
                <i class="fa fa-smile-o fa-2x"></i>
            </h2>
        </div>
    </div>
</template>

<script>
  export default {
    name: "Sac"
  }
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/Sac.vue